<template>
  <div>
    <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>

    <!-- 资源库页面  -->
    <div v-if="resourceFlag === 1">
      <!-- 弹框 -->
      <resource-edit
        ref="resourceEditForm"
        :title="resourceEditFormTitle"
        :visible="resourceEditFormVisible"
        :model="mdl"
        @cancel="handleCancel"
        @ok="handleOk"
      >
      </resource-edit>
      <a-card style="margin-top: 24px" :bordered="false">
        <!-- 新增区域 -->
        <div slot="title">
          <span>资源列表</span>
          <a-button
            type="primary"
            style="margin-left: 30px"
            icon="plus"
            @click="addResource"
            >添加</a-button
          >
        </div>
        <!-- 下划线 -->
        <div class="operate"></div>
        <!-- 搜索区域 -->
        <div slot="extra">
          <span>
            <a-select
              style="width: 250px"
              showSearch
              v-model="resourceQuery.currentUserId"
              :filter-option="filterOption"
              :defaultValue="0"
            >
              <a-select-option
                v-for="item in userListData"
                :key="item.id"
                :value="item.id"
                >{{ item.name }}
              </a-select-option>
            </a-select>
            <a-input-search
              style="width: 250px; margin-left: 10px"
              placeholder="请输入资源库名称"
              v-model="resourceQuery.name"
              @search="loadResourceDataList()"
            />
          </span>
        </div>

        <!-- 列表区域 -->
        <div
          :spinning="resourceListLoading"
          class="testDiv"
          v-for="(item, index) in resourceList"
          :key="index"
          @dblclick="openChildPath(item.id)"
        >
          <div class="tips">
            <a-popover placement="bottom">
              <template #content>
                <p style="cursor: pointer;" @click="editResource(item)">编辑</p>
                <p style="cursor: pointer;" @click="delResource(item.id)">删除</p>
              </template>
              <img src="@assets/imgs/more.png" width="20" />
            </a-popover>
          </div>

          <div class="content">
            <img src="@/assets/imgs/file.png" alt="" width="200" height="180" />
          </div>
          <div class="bottom">
            <p>{{ item.name }}</p>
          </div>
        </div>

        <!-- 分页区域 -->
        <div class="page">
          <a-pagination
            style="float: right; margin-right: 38px"
            v-model="resourcePagination.pageIndex"
            :page-size-options="['12', '24', '36', '48', '64', '96']"
            :total="resourcePagination.totalCount"
            :show-total="(total) => `共计 ${resourcePagination.totalCount} 项`"
            show-size-changer
            :page-size="resourcePagination.pageSize"
            @change="resourcePaginationPageChange"
            @showSizeChange="resourcePaginationPageSizeChange"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>
      </a-card>
    </div>
    <div v-else-if="resourceFlag == 2">
      <a-card style="margin-top: 24px" :bordered="false">
        <div slot="title">
          <span>资源库文件夹列表</span>
          <a-button
            type="primary"
            style="margin-left: 30px"
            @click="loadResourceDataList()"
            >返回</a-button
          >
        </div>
        <!-- 下划线 -->
        <div class="operate"></div>

        <div style="display: flex">
          <div
            class="fileList"
            v-for="item in resourceChildPathList"
            :key="item.id"
            @dblclick="loadFileList(item.id,item)"
          >
            <img src="@/assets/imgs/file.png" alt="" width="140" height="140" style="cursor: pointer;"/>
            <div class="nameDiv">{{ item.name }}</div>
          </div>
        </div>
      </a-card>
    </div>

    <!-- 图片页面  -->
    <div v-else-if="resourceFlag == 3" ref="resourceRight">
      <a-card style="width: 100%" :bordered="false">
        <div slot="title">
          <span>资源列表</span>
          <a-button
            type="primary"
            @click="openChildPath(currentResourceChildPathId)"
            style="margin-left: 30px"
          >
            返回
          </a-button>
          <a-button
            type="primary"
            @click="uploadValidata"
            style="margin-left: 10px"
            ><a-icon type="upload" />{{ uploadBtnTitle }}</a-button
          >
          <a-button
            type="primary"
            @click="checkFileAll"
            style="margin-left: 10px"
            >{{ checkboxAllText }}</a-button
          >
          <a-button
            type="primary"
            @click="checkFileDel"
            style="margin-left: 10px"
            >删除</a-button
          >
          <a-button
            type="primary"
            @click="clearFileAll"
            style="margin-left: 10px"
            >清空</a-button
          >
        </div>
        <!-- 下划线 -->
        <div class="operate"></div>
        <!-- 搜索区域 -->
        <div slot="extra">
          <a-input-search
            style="margin-left: 16px; width: 472px"
            placeholder="请输入文件名"
            v-model="fileQuery.fileName"
            @search="loadFileList(fileQuery.filePathId)"
          />
        </div>

        <!-- 列表区域  -->
        <a-list :grid="{ gutter: 16, column: 6 }" :loading="fileListLoading">
          <a-checkbox-group style="width: 100%" v-model="checkedValueList">
            <a-list-item :key="index" v-for="(item, index) in fileDataList">
              <a-card
                :hoverable="true"
                :class="card"
                ref="cards"
                style="width: 240px; height: 300px"
              >
                <img
                  slot="cover"
                  :alt="item.fileName"
                  :width="item.fileWidth"
                  :height="item.fileHeight"
                  :src="buildFilePath(item.imagePath)"
                  @click="viewerItem(item.imagePath)"
                />
                <template slot="actions">
                  <a-checkbox :id="bindId(item.id)" :value="item.id" />
                  <a-icon
                    key="setting"
                    type="eye"
                    @click="viewerItem(item.imagePath)"
                  />
                  <a-icon v-if="markFlag === 1"
                    type="highlight"
                    key="mark"
                    @click="gomark(item.id, item.imagePath, index)"
                  />
                  <a-icon
                    key="close"
                    type="close"
                    @click="removeItem(item.id)"
                  />
                </template>
                <a-card-meta :title="item.fileName"> </a-card-meta>
              </a-card>
            </a-list-item>
          </a-checkbox-group>
        </a-list>

        <!-- 分页区域 -->
        <div class="page" style="float: right; margin-right: 40px">
          <a-pagination
            v-model="filePagination.pageIndex"
            :page-size-options="['12', '24', '36', '48', '60', '72', '96']"
            :total="filePagination.totalCount"
            :show-total="(total) => `共计 ${filePagination.totalCount} 项`"
            show-size-changer
            :page-size="filePagination.pageSize"
            @showSizeChange="filePaginationSizeChange"
            @change="filefilePaginationPageChange"
          >
            <template #buildOptionText="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>

        <!-- 图片预览 -->
        <image-preview
          ref="imagePreview"
          :title="imagePreview.title"
          :filePreviewShow="imagePreview.visible"
          @close="closePreview"
          :imgList="imagePreview.imageList"
          :size="imagePreview.size"
          :currentImg="imagePreview.currentImg"
        >
        </image-preview>
      </a-card>
    </div>

    <!-- 查看标注文件  -->
    <div v-if="!ismark">
      <Mark
        :Colorindex="Colorindex"
        :imgurl="imgurl"
        :id="imgId"
        @changeismark="changemark"
        :filePathId="fileQuery.filePathId"
        :pageIndex="filePagination.pageIndex"
        :name="fileQuery.fileName"
        :pageSize="filePagination.pageSize"
      />
    </div>
    <!-- 上传文件  -->
    <uploader
      v-if="startUpload"
      :options="uploadOption"
      :file-status-text="statusText"
      :auto-start="true"
      class="uploader-example"
      ref="uploader"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      @file-removed="fileRemoved"
    >
      <a-button
        shape="circle"
        icon="close"
        style="float: right"
        @click="uploadValidata"
      ></a-button>
      <br />
      <br />
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
        <uploader-btn :attrs="attrs" style="background-color: #67c13b"
          ><i class="el-icon-upload" style="margin-right: 5px"></i
          >上传文件</uploader-btn
        >
        <i style="margin-right: 5px">{{ uploadFileCount }}/{{ fileCount }}</i>
      </uploader-drop>
      <uploader-list></uploader-list>
    </uploader>
  </div>
</template>

<script>
// 引入api
import {
  getResourcePageApi,
  addSemiResourceApi,
  updateSemiResourceApi,
  getSemiResourceChildApi,
  delSemiResourceApi,
  getSemiResourceApi,
  getFilePageApi,
  removeFilesApi,
  clearAllFilesApi,
} from "@api/semi_management";
// 引入组件
import CommentHeader from "@components/header";
import ImagePreview from "./ImagePreview";
import Mark from "./../SemiLabel";
import { requestUrl } from "@utils/request_url";
import ResourceEdit from "./ResourceEdit";

import { getCurrentOwnUserList } from "@api/userManagement";

export default {
  // 注册组件
  components: {
    CommentHeader,
    ImagePreview,
    Mark,
    ResourceEdit,
  },
  data() {
    return {
      // tab头部
      formLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 },
        },
      },
      fathertitle: "半监督学习",
      childtitle: "资源管理(半监督)",
      path: "/train/semiLearn/SemiResourceManage",
      mdl: null,
      // 页面是否展示标识
      resourceFlag: 1, //1:资源库 2：资源库固定子文件夹 3：文件列表
      resourceList: [],
      resourceChildPathList: [],
      currentResourceChildPathId: 0,
      fileList: [],
      resourceListLoading: false,

      userListData: [],
      currentUserId: "",
      // 资源库列表show
      fileListLoading: false,
      totalCount: 0,
      resourceQuery: {
        currentUserId: "",
        name: "",
        pid: 0,
      },
      resourcePagination: {
        pageSize: 12,
        pageIndex: 1,
        totalCount: 0,
        totalPages: 1,
      },

      resourceEditFormTitle: "",
      resourceEditFormVisible: false,
      // 文件夹列表

      fileDataList: [],
      fileQuery: {
        fileName: "",
        filePathId: 0,
      },
      filePagination: {
        pageSize: 12,
        pageIndex: 1,
        totalCount: 0,
        totalPages: 1,
      },

      listLoading: false,
      // 全选
      checkboxAllText: "全选",
      checkedValueList: [],
      checkAllStatus: false,

      // 图片适配压缩
      card: 2,
      zoomNum: null,

      // 图片预览
      imagePreview: {
        title: "图片预览",
        visible: false,
        imageList: [],
        currentImg: "",
        size: {},
      },
      // 标注
      Colorindex: 0,
      imgId: 0,
      imgurl: "",
      ismark: true,
      markFlag:0,

      // 上传
      uploadBtnTitle: "上传资源",
      startUpload: false,
      fileCount: 0,
      uploadFileCount: 0,
      errorfilelist: [], // 上传失败信息列表
      uploadOption: {
        target:
          requestUrl.replace("/api/", "") +
          "/zuul/api/train/rest/file/upload_semi_resource",
        maxChunkRetries: 2,
        testChunks: false,
        fileParameterName: "file",
        chunkSize: 1024 * 1024 * 1024,
        simultaneousUploads: 3,
        query: {
          filePathId: 0,
          flag: 0,
        },
        headers: {
          // 'Authorization': token
        },
      },
      statusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "暂停中",
        waiting: "等待中",
      },
      attrs: {
        accept: [".jpg", ".png", ".json", ".zip"],
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "form_in_modal" });
  },
  created() {
    // this.initData();
  },
  watch: {},
  beforeDestroy() {},
  mounted() {
    this.loadUsersData();
    this.loadResourceDataList();
  },
  methods: {
    loadResourceDataList() {
      const that = this;
      this.resourceFlag = 1;
      this.resourceListLoading = true;
      getResourcePageApi({
        pageIndex: that.resourcePagination.pageIndex,
        pageSize: that.resourcePagination.pageSize,
        name: that.resourceQuery.name,
        userId: that.resourceQuery.currentUserId,
        pid: 0,
      }).then((res) => {
        that.resourceList = res.data.list;
        that.resourcePagination.totalCount = res.data.totalRecords;
        that.resourceListLoading = false;
      });
    },
    resourcePaginationPageChange(page, pageSize) {
      this.resourcePagination.pageIndex = page;
      this.resourcePagination.pageSize = pageSize;
      this.loadResourceDataList();
    },
    resourcePaginationPageSizeChange(current, size) {
      this.resourcePagination.pageIndex = 1;
      this.resourcePagination.pageSize = size;
      this.loadResourceDataList();
    },
    openChildPath(resourceId) {
      if (this.startUpload) {
        this.startUpload = false;
        this.uploadBtnTitle = "上传资源";
      }
      this.resourceFlag = 2;
      this.currentResourceChildPathId = resourceId;
      const that = this;
      getSemiResourceChildApi({ pid: resourceId }).then((res) => {
        that.resourceChildPathList = res.data;
      });
    },
    loadFileList(pathId,item) {
      this.resourceFlag = 3;
      const that = this;
      this.fileQuery.filePathId = pathId;
      this.fileListLoading = true;
      if(item != null){
        if(item.name.indexOf("unlabel") > -1){    
          this.markFlag = 0;
        }else{
          this.markFlag = 1;
        }
      }
      getFilePageApi({
        pageIndex: that.filePagination.pageIndex,
        pageSize: that.filePagination.pageSize,
        filePathId: this.fileQuery.filePathId,
        fileName: that.fileQuery.fileName,
        markFlag:this.markFlag,
      }).then((res) => {
        that.fileDataList = [];
        if (res.data.list.length > 0) {
          const origHeight = 240;
          const origWight = 170;
          for (var i = 0; i < res.data.list.length; i++) {
            const element = res.data.list[i];
            var w = element.fileWidth;
            var h = element.fileHeight;
            element.realHeight = h;
            element.realWidth = w;
            if (w > h) {
              if (w > origHeight) {
                const scale = w / h;
                if (origHeight / scale > origWight) {
                  element.fileHeight = origWight + "px";
                  element.fileWidth = origWight * scale + "px";
                } else {
                  element.fileHeight = origHeight / scale + "px";
                  element.fileWidth = origHeight + "px";
                }
              }
            } else {
              if (h > origWight) {
                const scale = h / origWight;
                element.fileHeight = origWight + "px";
                element.fileWidth = w / scale + "px";
              }
            }
            that.fileDataList.push(element);
          }
        }
        that.filePagination.totalCount = res.data.totalRecords;
        that.fileListLoading = false;
      });
    },
    filefilePaginationPageChange(page, pageSize) {
      this.filePagination.pageIndex = page;
      this.filePagination.pageSize = pageSize;
      this.loadFileList(this.fileQuery.filePathId);
    },
    filePaginationSizeChange(current, pageSize) {
      this.filePagination.pageIndex = 1;
      this.filePagination.pageSize = pageSize;
      this.loadFileList(this.fileQuery.filePathId);
    },
    addResource() {
      this.resourceEditFormTitle = "新增资源库";
      if (
        this.$refs.resourceEditForm !== undefined ||
        this.$refs.resourceEditForm.form !== undefined
      ) {
        this.$refs.resourceEditForm.form.resetFields();
      }
      this.mdl = {
        id: 0,
        name: "",
      };
      this.resourceEditFormVisible=true;
    },
    editResource(row) {
      const that = this;
      this.resourceEditFormTitle = "编辑资源库";
      getSemiResourceApi({ id: row.id }).then((res) => {
        that.mdl = {
          id: row.id,
          name: res.data.name,
        };
        that.resourceEditFormVisible = true;
      });
    },
    handleOk() {
      const that = this;
      const form = this.$refs.resourceEditForm.form;
      form.validateFields((errors, values) => {
        if (!errors) {
          if (that.mdl.id == 0) {
            new Promise((resolve, reject)=>{
              setTimeout(() => {
                resolve()
              }, 500)
            }).then(res=>{
              addSemiResourceApi(values).then(r=>{
                that.resourceEditFormVisible=false;
                that.loadResourceDataList();
                that.$message.info('添加成功');
              });
            })
          } else {
            new Promise((resolve, reject)=>{
              setTimeout(() => {
                resolve()
              }, 500)
            }).then(res=>{
              values.id=that.mdl.id;
              updateSemiResourceApi(values).then(r=>{
                that.resourceEditFormVisible=false;
                that.loadResourceDataList();
                that.$message.info('保存成功');
              });
            })
          }
        }
      });
    },

    handleCancel() {
      if (
        this.$refs.resourceEditForm !== undefined ||
        this.$refs.resourceEditForm.form !== undefined
      ) {
        this.$refs.resourceEditForm.form.resetFields();
      }
      this.resourceEditFormVisible = false;
    },

    delResource(id) {
      const that = this;
      this.$confirm({
        title: `你想要删除此项吗（关联数据也会删除）?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              delSemiResourceApi({ id: id }).then((r) => {
                that.resourcePagination.pageIndex = 1;
                that.loadResourceDataList();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },

    checkFileAll() {
      if (this.startUpload) {
        this.startUpload = false;
        this.uploadBtnTitle = "上传资源";
      }
      if (!this.fileDataList.length) {
        return this.$message.warning("该目录下没有文件，请先上传");
      }
      if (!this.checkAllStatus) {
        this.checkAllStatus = true;
        var ids = [];
        this.fileDataList.forEach((item) => {
          ids.push(item.id);
        });
        this.checkedValueList = ids;
        this.checkboxAllText = "取消全选";
      } else {
        this.checkAllStatus = false;
        this.checkedValueList = [];
        this.checkboxAllText = "全选";
      }
    },
    /**
     * 删除
     */
    checkFileDel() {
      if (this.startUpload) {
        this.startUpload = false;
        this.uploadBtnTitle = "上传资源";
      }
      if (this.checkedValueList.length == 0) {
        this.$message.warning("请选择需要删除的文件");
      } else {
        const that = this;
        this.$confirm({
          title: `你想要删除此选择的文件吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                var ids = [];
                that.checkedValueList.forEach((item) => {
                  ids.push(item);
                });
                removeFilesApi({
                  filePathId: that.fileQuery.buildFilePath,
                  fileIds: ids,
                }).then((r) => {
                  that.filePagination.pageIndex = 1;
                  that.loadFileList(that.fileQuery.filePathId);
                });
              })
              .catch((err) => console.log(err));
          },
          autoFocusButton: null,
        });
      }
    },
    /**
     * 清空
     */
    clearFileAll() {
      if (this.startUpload) {
        this.startUpload = false;
        this.uploadBtnTitle = "上传资源";
      }
      const that = this;
      if (this.fileDataList.length <= 0) {
        return this.$message.warning("该目录下没有文件，请先上传");
      }
      this.$confirm({
        title: `你想要清空当前的图片列表吗?`,
        content: `当你点击确认按钮时, 自动更新列表`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              clearAllFilesApi({ filePathId: that.fileQuery.filePathId }).then(
                (r) => {
                  that.filePagination.pageIndex = 1;
                  that.loadFileList(that.fileQuery.filePathId);
                }
              );
            })
            .catch((err) => console.log(err));
        },
        autoFocusButton: null,
      });
    },

    buildFilePath(filePath) {
      return requestUrl + filePath;
    },
    /**
     * 查看图片（非页面压缩）
     * @param {压缩图片路径} filePath
     */
    viewerItem(filePath) {
      const that = this;
      that.imagePreview.imageList = [];
      that.fileDataList.forEach((item) => {
        var imgFile = requestUrl + item.imagePath.replace(/#/g, "%23");
        that.imagePreview.imageList.push(imgFile);
        that.imagePreview.size.height = item.fileHeight;
        that.imagePreview.size.width = item.fileWidth;
      });
      var orgimg = requestUrl + filePath;
      that.imagePreview.currentImg = orgimg.replace(/#/g, "%23");
      that.imagePreview.visible = true;
    },
    /**
     * 预览图片 关闭图标 ×
     */
    closePreview() {
      this.imagePreview.visible = false;
    },
    /**
     * 选中
     * @param {*} id
     */
    bindId(id) {
      return "checkbox_" + id;
    },
    gomark(id, path, index) {
      this.Colorindex = index;
      this.imgId = id;
      var img = requestUrl + path;
      this.imgurl = img.replace(/#/g, '%23');
      this.ismark = false;
      this.resourceFlag = 4;
    },
    /**
     * 查看标注文件返回
     */
    changemark(filePathId) {
      this.ismark = true;  
      this.loadFileList(filePathId);
    },
    /**
     * 删除
     * @param {*} id
     */
    removeItem(id) {
      this.checkedValueList = [];
      this.checkedValueList.push(id);
      this.checkFileDel();
    },

    /**
     * 上传
     */
    uploadValidata() {
      const self = this;
      if (this.startUpload) {
        if (this.uploadFileCount < this.fileCount) {
          this.$confirm({
            title: `资源还未上传完，您想强制关闭上传组件吗？`,
            content: `当你点击确认按钮时, 强制停止上传`,
            onOk() {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve();
                }, 500);
              })
                .then((res) => {
                  self.startUpload = false;
                  self.uploadBtnTitle = "上传资源";
                })
                .catch(() => console.log("小猪，出错啦，休息会吧!"));
            },
            autoFocusButton: null,
          });
        } else {
          if (this.uploadFileCount > 0) {
            self.loadFileList(self.fileQuery.filePathId);
          }
          this.startUpload = false;
          this.uploadBtnTitle = "上传资源";
        }
      } else {
        this.uploadOption.query.filePathId = this.fileQuery.filePathId;
        this.startUpload = true;
        this.fileCount = 0;
        this.uploadFileCount = 0;
        this.uploadBtnTitle = "取消上传";
      }
    },
    /**
     * 添加图片时进行校验
     * @param {*} file
     */
    onFileAdded(file) {
      const file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        file_type === "png" ||
        file_type === "jpg" ||
        file_type === "jpeg" ||
        file_type === "zip" ||
        file_type == "json";
      if (!extension) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: "文件不是 " + this.uploadType + " 格式",
        };
        const arr = file.relativePath.split("/");
        if (arr.length > 1) {
          obj["rootname"] = arr[0];
        }
        this.errorfilelist.push(obj);
        file.ignored = true;
      } else {
        file.resume();
      }
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
    },

    /**
     * 移除文件
     * @param {*} file
     */
    fileRemoved(file) {
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
    },
    // 上传错误触发，文件还未传输到后端
    onFileError(rootFile, file, response, chunk) {
      const obj = {
        rootname: "无",
        name: file.name,
        errorinfo: "文件上传失败",
      };
      if (rootFile.isFolder === true) {
        obj["rootname"] = rootFile.name;
      }
      this.errorfilelist.push(obj);
      this.controllerErrorFileDialog = true;
    },
    // 每个文件传输给后端之后，返回的信息
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response);
      if (res.code !== 10002) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: res.message,
        };
        if (rootFile.isFolder === true) {
          obj["rootname"] = rootFile.name;
        }
        this.errorfilelist.push(obj);
        this.controllerErrorFileDialog = true;
      } else {
        this.$nextTick(() => {
          this.uploadFileCount++;
        });
      }
    },

    loadUsersData() {
      const that = this;
      getCurrentOwnUserList().then((res) => {
        that.userListData = [];
        that.userListData.push({ id: "", name: "全部账户" });
        var list = res.data;
        if (list != null && list.length > 0) {
          for (var i = 0; i < list.length; i++) {
            that.userListData.push({
              id: list[i].id,
              name: list[i].accountRealName,
            });
          }
        }
      });
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style scoped lang="less">
.uploader-example {
  background-color: white;
  width: 600px;
  padding: 15px;
  margin: 0 auto 0;
  font-size: 14px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
  z-index: 9999;
  top: 300px;
  left: 55%;
  position: fixed;
}

.uploader-example .uploader-btn {
  margin-right: 8px;
  color: #ffffff;
  border: #ffffff;
}

/deep/ .uploader-example .uploader-list {
  max-height: 300px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;

  .uploader-file[status="uploading"] > .uploader-file-info {
    > .uploader-file-status > span > i {
      visibility: hidden;
    }

    > .uploader-file-status > span > em {
      visibility: hidden;
    }
  }
}

.card {
  width: 220px;
  height: 300px;
}

.card2 {
  width: 180px;
  height: 300px;
}

.ant-upload-list-item-done .ant-upload-list-item-name {
  color: green !important;
}

.ant-upload-list-item-done .anticon-paper-clip {
  color: green !important;
}

.ant-card-actions {
  bottom: 0px;
  position: absolute;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  zoom: 1;
  width: 100%;
}

/deep/.ant-card-cover {
  height: 200px;
  width: auto;
  justify-items: center;
  align-items: center;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ant-card-cover img {
  border-radius: 2px 2px 0 0;
  width: auto;
  margin: 0 auto;
}

.ant-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 10;
  font-size: 8px;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  text-align: center;
}

.testDiv {
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 260px;
  height: 260px;
  margin-right: 40px;
  margin-bottom: 20px;

  .tips {
    width: 20px;
    border-radius: 50%;
    position: absolute;
    top: 15px;
    right: 10px;
    opacity: 0;
  }

  .content {
    height: 120px;
    margin: 30px 5px;
    text-align: center;
  }

  .bottom {
    margin-left: 100px;
    margin-top: 50px;
    width: 55px;
    height: 30px;
    text-align: center;
    line-height: 60px;

    p {
      color: #001;
      font-size: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.testDiv:hover {
  background-color: rgba(241, 243, 244, 1);
}

.testDiv:hover .tips {
  z-index: 2001;
  opacity: 1 !important;
}

// 文件夹页面样式

.nameDiv {
  margin-left: 40px;
  margin-top: 10px;
  white-space: nowrap; //禁止换行
  overflow: hidden;
  text-overflow: ellipsis; //...
}

.fileList {
  margin: 30px 40px;
}
</style>

